import React, { useContext, useEffect, useState } from 'react'
import { PersonOutlined, ChatBubbleOutlineOutlined } from '@material-ui/icons'
import { Link } from 'react-router-dom'

import { MessengerContext } from '../../context/MessengerContext'


import './chatCurrent.css'

const ChatOnline = () => {

  const [user, setUser] = useState({})
  const [conversation, setConversation] = useContext(MessengerContext)

  const API = process.env.REACT_APP_API_URL
  const PF = process.env.REACT_APP_PUBLIC_FOLDER

  useEffect(() => {
    setUser(conversation.communicator)
  }, [conversation])

  return (
    conversation.communicator
    ?
    <div className="chatCurrent">
        <div className="chatCurrentWrapper">
            <div className="currentInfo">
              <div className='currentProfileImageWrapper'>
                <img className='currentProfileImg' src={conversation.communicator.profilePicture || (PF + "person/default_avatar.jpg")} alt="" />
              </div>
              <div style={{ marginBottom: '4rem' }}>
                <p className='currentUsername'>{conversation.communicator.username}</p>
                <p className='currentEmail'>{conversation.communicator.email}</p>
              </div>
              <Link to={`profile/${conversation.communicator.username}`} style={{textDecoration: "none", color: "#111"}}>
                <div className='action'>
                  <PersonOutlined />
                  <p style={{ marginLeft: '1rem', marginBottom: '0' }}>Go to profile</p>
                </div>
              </Link> 
              <div className='action'>
                  <ChatBubbleOutlineOutlined />
                  <p style={{ marginLeft: '1rem', marginBottom: '0' }} onClick={() => {document.getElementById('sendMessageInput').focus()}}>Send a message</p>
              </div>
            </div>
        </div>
    </div>
    :
    console.log('makaynch')
  )
}

export default ChatOnline